import { createSelector } from 'reselect';
import { getProfileState } from 'src/modules/profile/selectors/getProfileState';

export const getProfileForm = createSelector([
  getProfileState,
], (state) => state.form);
